import React from 'react';
import { useLanguage } from '../hooks/useLanguage';
import { Select, MenuItem, FormControl, SelectChangeEvent, SxProps, Theme } from '@mui/material';
import { useTranslation } from 'react-i18next';

const languageNames = {
  en: 'English',
  fr: 'Français'
};

interface LanguageSelectorProps {
  sx?: SxProps<Theme>;
}

export const LanguageSelector: React.FC<LanguageSelectorProps> = ({ sx }) => {
  const { getCurrentLanguage, changeLanguage, getAvailableLanguages } = useLanguage();
  const { t } = useTranslation();

  const handleChange = (event: SelectChangeEvent<string>) => {
    changeLanguage(event.target.value);
  };

  return (
    <FormControl size="small" sx={{ minWidth: 120, my: 1, ...sx }}>
      <Select
        value={getCurrentLanguage()}
        onChange={handleChange}
        sx={{
          '& .MuiSelect-select': {
            py: 1
          }
        }}
      >
        {getAvailableLanguages().map((lang) => (
          <MenuItem key={lang} value={lang}>
            {languageNames[lang as keyof typeof languageNames]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default LanguageSelector;
